import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      display: 'flex',
      height: '100%',
      userSelect: 'none',
      touchAction: 'none',
    },
    common: {
      position: 'relative',
    },
    hueVertical: {
      height: '100%',
      width: 24,

      '& .hue-vertical': {
        borderRadius: 4,
      },
    },
    hueHorizontal: {
      height: 24,
      width: '100%',

      '& .defaultHuePointer': {
        transform: 'translate(-16px, -4px)',
      },
    },
    saturation: {
      flex: 1,
      height: '100%',

      '&>div': {
        borderRadius: 4,

        '& .saturation-black': {
          borderRadius: 4,
        },
      },
    },
  },
  { name: 'Picker' },
);

export const useSaturationPointerStyles = createUseStyles(
  {
    root: {
      border: '6px solid #FFF',
      borderRadius: '50%',
      cursor: 'pointer',
      filter:
        'drop-shadow(0px 2px 4px rgba(31, 41, 55, 0.06)) drop-shadow(0px 4px 6px rgba(31, 41, 55, 0.1))',
      transform: 'translate(-16px, -16px)',
      height: 32,
      width: 32,
    },
  },
  { name: 'SaturationPointer' },
);

export const useHuePointerStyles = createUseStyles(
  {
    root: {
      backgroundColor: '#fff',
      borderRadius: '50%',
      cursor: 'pointer',
      boxShadow: '0px 4px 16px rgba(17, 18, 54, 0.16)',
      transform: 'translate(-4px, -16px)',
      height: 32,
      width: 32,
    },
  },
  { name: 'HuePointer' },
);
